import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function Hero() {
  return <div className="relative min-h-screen flex items-center pt-32 md:pt-20 pb-12 md:pb-20 overflow-hidden bg-white" data-id="element-218">
      {/* Subtle red gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-50/30 via-white to-red-50/20 z-0" data-id="element-219" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-220">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-221">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-222">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-red-light text-brand-red-dark font-medium text-sm mb-6" data-id="element-223">
              <span className="relative flex h-2 w-2" data-id="element-224">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-red opacity-75" data-id="element-225"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-red" data-id="element-226"></span>
              </span>
              Trusted Insurance Brokers Since 2022
            </motion.div>

            <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-brand-black leading-tight mb-6 tracking-tight" data-id="element-227">
              Insurance Built for the{' '}
              <span className="text-brand-red" data-id="element-228">Modern World</span>.
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-lg leading-relaxed" data-id="element-229">
              Protect what matters most — with tailored insurance brokerage
              services built on integrity, expertise, and innovation.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-230">
              <Button size="lg" className="shadow-lg shadow-brand-red/20" data-id="element-231">
                Get Started Now <ArrowRight className="ml-2 h-5 w-5" data-id="element-232" />
              </Button>
              <Button variant="outline" size="lg" data-id="element-233">
                View Coverage Plans
              </Button>
            </div>

            <div className="flex items-center gap-8 text-sm font-medium text-gray-500" data-id="element-234">
              <div className="flex items-center gap-2" data-id="element-235">
                <ShieldCheck className="h-5 w-5 text-brand-red" data-id="element-236" />
                <span data-id="element-237">A+ Rated Security</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-238">
                <div className="flex -space-x-2" data-id="element-239">
                  {[1, 2, 3].map(i => <div key={i} className="h-8 w-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs overflow-hidden" data-id="element-240">
                      <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${i}`} alt="User" data-id="element-241" />
                    </div>)}
                </div>
                <div className="flex flex-col leading-none" data-id="element-242">
                  <span className="font-bold text-brand-black" data-id="element-243">50K+</span>
                  <span className="text-xs" data-id="element-244">Active Members</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Insurance illustration - Now visible on mobile */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mt-8 lg:mt-0" data-id="element-245">
            <div className="flex items-center justify-center" data-id="element-246">
              <img src="https://cdn.magicpatterns.com/uploads/5GSo45xfU1qBLB28zaxS5H/INSURANCE_ELEMENT.png" alt="Family protection with comprehensive insurance coverage" className="w-full h-auto max-w-[500px] lg:max-w-[600px]" data-id="element-247" />
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}